export default __webpack_public_path__ + "static/media/pearl-2.8b161414.png";